export enum EmailIntegrationType {
  SMTP = "SMTP",
  OFFICE_365 = "Office365",
}
